import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import AccessibilityWidget from "./components/AccessibilityWidget";
import Home from "./views/Home";
import LawyerBeerSheva from "./views/pages/LawyerBeerSheva";
import TrafficLawyerBeerSheva from "./views/pages/TrafficLawyerBeerSheva";
import PowerOfAttorney from "./views/pages/PowerOfAttorney";
import ServicePage from "./views/pages/ServicePage";

const App = () => {
  useEffect(() => {
    AOS.init();
    document.body.classList.add("loaded");
  }, []);

  return (
    <HelmetProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/orech-din-beer-sheva" element={<LawyerBeerSheva />} />
        <Route path="/orech-din-taaruva" element={<TrafficLawyerBeerSheva />} />
        <Route path="/yipui-koach-metumshach" element={<PowerOfAttorney />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <AccessibilityWidget />
    </HelmetProvider>
  );
};

export default App;
